import type { Dictionary } from '../i18n.js';
import { common } from './common.js';
import { wizard } from './wizard.js';
import { lobby } from './lobby.js';
import { shelves } from './shelves.js';
import { account } from './account.js';
import { server } from './server.js';
import { shell } from './shell.js';
import { race } from './race.js';
import { build } from './build.js';

/**
 * Polish, split by the part of the game it belongs to so that a translator can find a
 * sentence and so that two people translating two panels do not edit the same file.
 *
 * The same English in two parts must say the same Polish — `tests/i18n.test.ts` holds them
 * to it — so a word every panel uses lives in `common` rather than in each of them.
 * `server` is the odd one out: those are sentences the server sends already formatted, and
 * they are matched rather than looked up. See `serverText`.
 */
export const PL_PARTS: Record<string, Dictionary> = { common, wizard, lobby, shelves, account, race, build, server, shell };

export const pl: Dictionary = Object.assign({}, ...Object.values(PL_PARTS));
